<template>
  <div class="report-section report-section-collapsible">
    <button
      type="button"
      class="report-section-toggle"
      :aria-expanded="isOpen"
      @click="$emit('update:isOpen', !isOpen)"
    >
      <h2 class="report-section-heading">{{ title }}</h2>
      <i class="material-icons report-section-chevron">{{ isOpen ? 'expand_less' : 'expand_more' }}</i>
    </button>
    <div v-show="isOpen" class="card report-table-card">
      <div v-if="!isEmpty">
        <slot />
      </div>
      <p v-else class="report-no-data">{{ emptyMessage }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ReportTableSection',
  props: {
    title: {
      type: String,
      required: true
    },
    isOpen: {
      type: Boolean,
      required: true
    },
    isEmpty: {
      type: Boolean,
      required: true
    },
    emptyMessage: {
      type: String,
      required: true
    }
  },
  emits: ['update:isOpen']
};
</script>

<style scoped>
.report-section {
  margin-bottom: var(--space-xl);
}

.report-section-collapsible {
  margin-bottom: var(--space-md);
}

.report-section-toggle {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: var(--space-sm) 0;
  border: none;
  background: none;
  cursor: pointer;
  color: inherit;
  text-align: left;
}

.report-section-toggle:hover .report-section-heading {
  color: var(--color-text);
}

.report-section-chevron {
  font-size: 1.25rem;
  color: var(--color-text-muted);
  flex-shrink: 0;
  margin-left: var(--space-sm);
}

.report-section-heading {
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: var(--color-text-secondary);
  margin: 0;
}

.report-table-card {
  padding: 0;
  display: block;
  overflow: hidden;
}

.report-no-data {
  padding: var(--space-lg);
  margin: 0;
  font-size: 0.9rem;
  color: var(--color-text-muted);
  text-align: center;
}
</style>
